import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-rostering',
  templateUrl: './create-rostering.component.html',
  styleUrls: ['./create-rostering.component.css']
})
export class CreateRosteringComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
